import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfDraftSubmitInput } from "@colab/shared";

// POST /api/portal/mdf/drafts/:id/submit — promote draft → pending.
//
// Pessimistic. The HubSpot Note dispatch happens fire-and-forget inside
// the worker (matches Phase 4 service behavior); the response returns the
// row id only. No 3-way result split — see MIGRATION.md bucket-9 note.
//
// onSuccess invalidates the list, the detail, AND the draft cache. Phase 7
// pages typically navigate to the request detail after a successful submit;
// the navigation is the caller's concern (hooks do not touch the router).
export function useSubmitMdf(draftId: string) {
  const queryClient = useQueryClient();
  return useMutation<{ id: string }, ApiClientError, MdfDraftSubmitInput>({
    mutationFn: (body) =>
      apiFetch<{ id: string }>(`/portal/mdf/drafts/${draftId}/submit`, {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: ({ id }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.requests() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.request(id) });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.draft(draftId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to submit request");
    },
  });
}
